import React from 'react';
import GUI from '../containers/gui.jsx';

const searchParams = new URLSearchParams(location.search);
const cloudHost = searchParams.get('cloud_host') || 'wss://clouddata.turbowarp.org';
let showOpusInfo = false;
const username = searchParams.get('username');
if(username){
    showOpusInfo = true;
}

const RenderGUI = props => (
    <GUI
        cloudHost={cloudHost}
        canSave={false}
        basePath={process.env.ROOT}
        canEditTitle
        showOpusInfo = {showOpusInfo}
        username = {username}
        enableCommunity
        {...props}
    />
);

export default RenderGUI;
